<template>
  <panel
    :on-hide="onHide"
    :store="store"
    title="Subscribe"
  >
    <template slot="footer">
      <a
        v-if="hideItems"
        :href="`${store.state.episode.episode_url}?subscribe=true`"
        class="subscribe-tools"
        target="simplecast-share"
        title="More Subscribe Options"
        @click="store.sendShareSubscribeEvent('share', ' CLICK', 'share')"
      >More Options <icon-open /></a>
    </template>
    <ul class="subscribe-links">
      <li v-if="getChannelUrl('Apple Podcasts')">
        <a
          :href="getChannelUrl('Apple Podcasts')"
          title="Apple Podcasts"
          target="simplecast"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Apple Podcasts')">
          <icon-apple-podcasts />
        </a>
      </li>
      <li v-if="getChannelUrl('Spotify')">
        <a
          :href="getChannelUrl('Spotify')"
          title="Spotify"
          target="simplecast"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Spotify')">
          <spotify />
        </a>
      </li>
      <li v-if="getChannelUrl('Google Podcasts')">
        <a
          :href="getChannelUrl('Google Podcasts')"
          target="simplecast"
          title="Google Podcasts"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Google Podcasts')">
          <google-podcasts />
        </a>
      </li>
      <li v-if="getChannelUrl('Radio.com')">
        <a
          :href="getChannelUrl('Radio.com')"
          target="simplecast"
          title="Radio.com"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Radio.com')">
          <radio-dark-mode v-if="isDark" />
          <radio v-else />
        </a>
      </li>
      <li
        v-if="getChannelUrl('Breaker')"
        :class="{smHide: hideItems}">
        <a
          :href="getChannelUrl('Breaker')"
          target="simplecast"
          title="Breaker"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Breaker')">
          <breaker />
        </a>
      </li>
      <li
        v-if="getChannelUrl('Deezer')"
        :class="{smHide: hideItems}">
        <a
          :href="getChannelUrl('Deezer')"
          target="simplecast"
          title="Deezer"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Deezer')">
          <deezer />
        </a>
      </li>
      <li
        v-if="getChannelUrl('iHeartRadio')"
        :class="{smHide: hideItems}">
        <a
          :href="getChannelUrl('iHeartRadio')"
          target="simplecast"
          title="iHeartRadio"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'iHeartRadio')">
          <iheart />
        </a>
      </li>
      <li
        v-if="getChannelUrl('Overcast')">
        <a
          :href="getChannelUrl('Overcast')"
          target="simplecast"
          title="Overcast"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Overcast')">
          <overcast />
        </a>
      </li>
      <li
        v-if="getChannelUrl('Pandora')">
        <a
          :href="getChannelUrl('Pandora')"
          target="simplecast"
          title="Pandora"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Pandora')">
          <pandora />
        </a>
      </li>
      <li
        v-if="getChannelUrl('Pocketcast')">
        <a
          :href="getChannelUrl('Pocketcast')"
          target="simplecast"
          title="Pocket Casts"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Pocketcast')">
          <pocket-casts />
        </a>
      </li>
      <li
        v-if="getChannelUrl('RadioPublic')"
        :class="{smHide: hideItems}">
        <a
          :href="getChannelUrl('RadioPublic')"
          target="simplecast"
          title="RadioPublic"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'RadioPublic')">
          <radio-public />
        </a>
      </li>
      <li
        v-if="getChannelUrl('Stitcher')">
        <a
          :href="getChannelUrl('Stitcher')"
          target="simplecast"
          title="Stitcher"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Stitcher')">
          <stitcher />
        </a>
      </li>
      <li
        v-if="getChannelUrl('Tune In')"
        :class="{smHide: hideItems}">
        <a
          :href="getChannelUrl('Tune In')"
          target="simplecast"
          title="Tune In"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'Tune In')">
          <tune-in />
        </a>
      </li>
      <li v-if="rssUrl">
        <a
          :href="rssUrl"
          target="simplecast"
          title="RSS Link"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'RSS Link')"
        ><IconRss /></a>
      </li>
    </ul>
  </panel>
</template>

<script>
import Panel from './Panel'
import IconRss from '../assets/svg/rss.svg'
import Breaker from '../assets/svg/breaker.svg'
import GooglePodcasts from '../assets/svg/google-podcasts.svg'
import IconApplePodcasts from '../assets/svg/apple-podcasts.svg'
import Iheart from '../assets/svg/iheart.svg'
import Overcast from '../assets/svg/overcast.svg'
import Pandora from '../assets/svg/pandora.svg'
import PocketCasts from '../assets/svg/pocket-casts.svg'
import RadioPublic from '../assets/svg/radiopublic.svg'
import Spotify from '../assets/svg/spotify.svg'
import Stitcher from '../assets/svg/stitcher.svg'
import TuneIn from '../assets/svg/tune-in.svg'
import Deezer from '../assets/svg/deezer.svg'
import Radio from '../assets/svg/radio-dark.svg'
import RadioDarkMode from '../assets/svg/radio-light.svg'
import IconOpen from '../assets/svg/open.svg'

export default {
  components: {
    Panel,
    IconRss,
    Breaker,
    GooglePodcasts,
    IconApplePodcasts,
    Iheart,
    Overcast,
    Pandora,
    PocketCasts,
    RadioPublic,
    Spotify,
    Stitcher,
    TuneIn,
    Deezer,
    Radio,
    RadioDarkMode,
    IconOpen
  },
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  computed: {
    hideItems () {
      return this.store.state.distributionChannels.length > 8 && !window.getUrlParameter('show')
    },
    isDark () { return this.store.state.isDark },
    episodeUrl () {
      return this.store.state.episode.custom_url && this.store.state.episode.custom_url !== '' ? this.store.state.episode.custom_url : this.store.state.episode.episode_url
    },
    itunesUrl () {
      if (this.store.state.podcast.itunes_url && this.store.state.podcast.itunes_url !== '') {
        return this.store.state.podcast.itunes_url
      }

      return false
    },
    rssUrl () {
      if (this.store.state.podcast.external_feed_url && this.store.state.podcast.external_feed_url !== '') {
        return this.store.state.podcast.external_feed_url
      }
      if (this.store.state.podcast.feed_url && this.store.state.podcast.feed_url !== '') {
        return this.store.state.podcast.feed_url
      }

      return false
    },
    size () { return this.store.state.size }
  },
  methods: {
    onHide () {
      this.store.setShowSubscribe(false)
    },
    getChannelUrl (name) {
      let c = this.store.state.distributionChannels && this.store.state.distributionChannels.find(channel => {
        if (channel.distribution_channel) return channel.distribution_channel.name === name

        return channel.name === name
      })
      return c && c.url
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.subscribe-links{
  display: block;
  flex-wrap: wrap;
  margin: 0;
  list-style: none;
  padding: 0;
  margin: -6px -16px;

  li {
    padding: 6px 16px;
    display: inline-block;
    svg {
      height: 24px;
      width: 24px;
    }
  }
}
.subscribe-tools {
  display: none;
}

.panel-small {
  .subscribe-tools {
    display: inline-flex;
    text-decoration: none;
    font-family: RobotoMono-Regular;
    font-size: 12px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    align-items: center;
    svg {
      order: -1;
      margin-right: 8px;
    }
  }
  .smHide {
    display: none;
  }
  .subscribe-links {
    li {
      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
}
.panel-smallest {
  .subscribe-links {
    margin: -3px -8px;
    li {
      padding: 3px 8px;
      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
}
</style>
